import { useState } from "react";
import { generateFile } from "../../api/referral";
import { FaFileDownload, FaSpinner, FaInfoCircle } from "react-icons/fa";
import {
  showLoadingAlert,
  showDownloadSuccessAlert,
  showDownloadErrorAlert,
} from "./withdrawalAlerts";

const FileDownloadSection = () => {
  const [loading, setLoading] = useState(false);

  const handleDownloadFile = async () => {
    setLoading(true);
    try {
      const loadingSwal = showLoadingAlert(
        "Generando archivo...",
        "Por favor espere mientras se genera el archivo de pagos"
      );

      const response = await generateFile();

      const blob = new Blob([response], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `pagos-referidos-${
        new Date().toISOString().split("T")[0]
      }.csv`;

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      loadingSwal.close();

      showDownloadSuccessAlert();
    } catch (error) {
      console.error("Error al generar el archivo de pagos:", error);
      showDownloadErrorAlert();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2>Archivo de Pagos para Tesorería</h2>
      </div>
      <div className="card-body">
        <div className="info-alert">
          <FaInfoCircle className="info-icon" />
          <div className="info-text">
            <p>
              El archivo generado incluirá todos los pagos pendientes que aún no
              han sido procesados por tesorería.
            </p>
          </div>
        </div>

        <div className="action-container">
          <button
            className="btn-primary"
            onClick={handleDownloadFile}
            disabled={loading}
          >
            {loading ? (
              <>
                <FaSpinner className="spinner" /> Generando archivo...
              </>
            ) : (
              <>
                <FaFileDownload /> Descargar Archivo de Pagos
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileDownloadSection;
